class ConfiguracaoPisCofins {
    static get atividades() {
        return [
            { id: "AGROINDUSTRIA", nome: "Agroindustria" },
            { id: "CONCESSIONARIA", nome: "Concessionária de veículos autorizadas pelo fabricante" },
            { id: "INDUSTRIA", nome: "Industria" },
            { id: "SERVICO", nome: "Serviço" },
            { id: "INDUSTRIA_FRIGORIFICO", nome: "Industria Frigorífico" },
            { id: "COMERCIO", nome: "Comércio Varejista [Lucro Real ou Presumido]" },
            { id: "COMERCIO_SNA", nome: "Comércio Varejista [Simples Nacional]" },
            { id: "ATACADO", nome: "Comércio Atacadista, exceto de Bebidas Frias [Lucro real ou Presumido]" }
        ]
    }

    constructor(gql, $scope, parametrosTributarios) {
        this.gql = gql
        this.pisCofins = {}
        this.apply = fun => $scope.$apply(fun)
        this.atividades = ConfiguracaoPisCofins.atividades
        this.parametrosTributarios = parametrosTributarios
        $scope.$watch(() => JSON.stringify(this.model), () => {
            if (this.model) {
                this.onChange({ pisCofins: this.formatModel(this.model) })
            }
        })
    }

    $onChanges({ pisCofins }) {
        if (pisCofins) {
            this.form && this.form.$setPristine()
            this.model = this.parseModel(pisCofins.currentValue)
        }
    }

    $onInit() {
        this.promise = this
            .loadParametrosPisCofins()
            .then(({ regimesTributarios }) => {
                this.regimesTributarios = regimesTributarios
                this.model = this.parseModel(this.pisCofins)
            })
    }

    onRegimeSelect() {
        const { aliquotaPis, aliquotaCofins } = this.model.regimeTributario
        this.model.aliquotaPis = aliquotaPis
        this.model.aliquotaCofins = aliquotaCofins
    }

    loadParametrosPisCofins() {
        const query = gql`
            query ParametrosPisCofins {
                parametrosPisCofins{
                    regimesTributarios {
                        id
                        nome
                        aliquotaPis
                        aliquotaCofins
                    }
                }
            }
        `
        return this.gql
            .query(query)
            .then(({ parametrosPisCofins }) => parametrosPisCofins)
    }

    submit() {
        if (!this.form.$valid) return;
        const pisCofins = this.formatModel(this.model)
        if (this.model.id) {
            this.updatePisCofins(pisCofins)
        } else {
            this.createPisCofins(pisCofins)
        }
    }
    
    createPisCofins(pisCofins) {
        this.promise = this.parametrosTributarios
            .createFilialPisCofins(this.empresaId, { id: this.filialId }, pisCofins)
            .then((pisCofins) => this.onSave({ pisCofins }))
            .catch(errors => this.onError(errors))
            .finally(() => this.apply())
    }

    updatePisCofins(pisCofins) {
        this.promise = this.parametrosTributarios
            .updateFilialPisCofins(this.empresaId, pisCofins)
            .then((pisCofins) => this.onSave({ pisCofins }))
            .catch(errors => this.onError(errors))
            .finally(() => this.apply())
    }

    onError(errors) {
        this.form.vigencia.$setValidity('overlap', !errors.some(e => e.key === 'vigencia'))
        this.onErrors({ errors: errors, pisCofins: this.formatModel(this.model) })
    }
    onVigenciaChange() {
        if (this.model.vigencia) {
            this.form.vigencia.$setValidity('overlap', true)
        }
    }

    parseModel(pisCofins) {
        if (pisCofins && this.regimesTributarios) {
            let { id, regimeTributarioId, aliquotaPis, aliquotaCofins, atividade, vigencia } = pisCofins
            let regimeTributario = this.regimesTributarios.find(regime => regime.id === regimeTributarioId)
            atividade = this.atividades.find(at => at.id === atividade)
            return {
                id,
                aliquotaPis,
                aliquotaCofins,
                atividade,
                regimeTributario,
                vigencia: {
                    inicial: vigencia && vigencia.from && this.fromDateString(vigencia.from),
                    final: vigencia && vigencia.to && this.fromDateString(vigencia.to)
                }
            }
        }
        return null
    }

    formatModel(model) {
        const { id, aliquotaPis, aliquotaCofins, atividade, regimeTributario, vigencia } = model
        return {
            id,
            aliquotaPis: parseFloat(aliquotaPis),
            aliquotaCofins: parseFloat(aliquotaCofins),
            atividade: atividade ? atividade.id : null,
            regimeTributarioId: regimeTributario ? regimeTributario.id : null,
            vigencia: {
                from: this.toDateString(vigencia?.inicial),
                to: this.toDateString(vigencia?.final)
            }
        }
    }

    toDateString(date) {
        return date ? date.toISODateWithoutTimezone() : null
    }

    fromDateString(str) {
        return new Date(str.split("-"))
    }
}
angular
    .module('eficienciaFiscalModule')
    .component('configuracaoPisCofins', {
        controller: ['gql', '$scope', 'ParametrosTributarios', ConfiguracaoPisCofins],
        bindings: {
            empresaId: '<',
            filialId: '<',
            pisCofins: '<',
            onSave: '&',
            onErrors: '&',
            onChange: '&'
        },
        template: `
            <loading promise="$ctrl.promise">
                <form name="$ctrl.form" ng-submit="$ctrl.submit()" novalidate>
                    <div class="pure-g">
                        <div class="pure-u-1-1 form-group">
                            <label>Vigência</label>
                            <periodo-input
                                ng-change="$ctrl.onVigenciaChange()"
                                ng-model="$ctrl.model.vigencia"
                                name="vigencia">
                            </periodo-input>
                            <div ng-messages="$ctrl.form.vigencia.$error" ng-if="$ctrl.form.$submitted">
                                <span
                                    class='help-block txt-color-red font-xs no-margin'
                                    ng-message="timeRange">A data final deve ser superior à data inicial.
                                </span>
                                <span
                                    class='help-block txt-color-red font-xs no-margin'
                                    ng-message="overlap">O período informado conflita com alguma outra configuração.
                                </span>
                            </div>
                        </div>
                        <div class="pure-u-1-1 form-group">
                            <label>Regime tributário</label>
                            <ui-select
                                theme="bootstrap"
                                name="regimeTributario"
                                ng-model="$ctrl.model.regimeTributario"
                                ng-change="$ctrl.onRegimeSelect()"
                                required>
                                <ui-select-match placeholder="Clique aqui para selecionar um regime tributário.">
                                    {{$select.selected.nome}}
                                </ui-select-match>
                                <ui-select-choices repeat="regime in $ctrl.regimesTributarios | filter: $select.search">
                                    <div>{{regime.nome}}</div>
                                </ui-select-choices>
                            </ui-select>
                            <div ng-messages="$ctrl.form.regimeTributario.$error" ng-if="$ctrl.form.$submitted">
                                <span
                                    class='help-block txt-color-red font-xs no-margin'
                                    ng-message="required">Selecione um regime tributário.
                                </span>
                            </div>
                        </div>
                        <div class="pure-u-1-2 form-group">
                            <label>Alíquota PIS</label>
                            <input class="form-control" money="{prefix:'', centsLimit: 2}", name="aliquotaPis" ng-model="$ctrl.model.aliquotaPis" required>
                            <div ng-messages="$ctrl.form.aliquotaPis.$error" ng-if="$ctrl.form.$submitted">
                                <span
                                    class='help-block txt-color-red font-xs no-margin'
                                    ng-message="required">Informe uma alíquota PIS.
                                </span>
                            </div>
                        </div>
                        <div class="pure-u-1-2 form-group">
                            <label>Alíquota COFINS</label>
                            <input class="form-control" money="{prefix:'', centsLimit: 2}", name="aliquotaCofins" ng-model="$ctrl.model.aliquotaCofins" required>
                            <div ng-messages="$ctrl.form.aliquotaCofins.$error" ng-if="$ctrl.form.$submitted">
                                <span
                                    class='help-block txt-color-red font-xs no-margin'
                                    ng-message="required">Informe uma alíquota COFINS.
                                </span>
                            </div>
                        </div>
                        <div class="pure-u-1-1 pure-u-md-2-3 form-group">
                            <label>Atividade</label>
                            <ui-select
                                theme="bootstrap"
                                name="atividade"
                                ng-model="$ctrl.model.atividade"
                                required>
                                <ui-select-match placeholder="Clique aqui para selecionar uma atividade.">
                                    {{$select.selected.nome}}
                                </ui-select-match>
                                <ui-select-choices repeat="atividade in $ctrl.atividades | filter: $select.search">
                                    <div>{{atividade.nome}}</div>
                                </ui-select-choices>
                            </ui-select>
                            <div ng-messages="$ctrl.form.atividade.$error" ng-if="$ctrl.form.$submitted">
                                <span
                                    class='help-block txt-color-red font-xs no-margin'
                                    ng-message="required">Selecione uma atividade.
                                </span>
                            </div>
                        </div>
                        <div class="pure-u-1-1 pure-u-md-1-3 form-group">
                            <label class="hidden-xs">&nbsp;</label>
                            <button class="btn btn-block btn-primary" ng-disabled="isLoading">
                                <span ng-show="isLoading">Salvando...</span>
                                <span ng-hide="isLoading">Salvar</span>
                            </button>
                        </div>
                    </div>
                </form>
            </loading>
        `
    })

export default ConfiguracaoPisCofins
